export default __webpack_public_path__ + "static/media/portfolio-big-01.cda48b81.jpg";